module.exports = __webpack_public_path__ + "static/media/dolly.97e64481.svg";